module.exports = __webpack_public_path__ + "assets/images/lang-arrow-down.svg";